// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_M7p","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_Xsc StatelessWorkCardsUpsellModal-styles-cls1_M7p"};